import { render, staticRenderFns } from "./ArtistItems.vue?vue&type=template&id=2195ee50&scoped=true"
import script from "./ArtistItems.vue?vue&type=script&lang=js"
export * from "./ArtistItems.vue?vue&type=script&lang=js"
import style0 from "./ArtistItems.vue?vue&type=style&index=0&id=2195ee50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195ee50",
  null
  
)

export default component.exports